import { useEffect, useRef } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const KEY = "vw_handoff_seen";
const POLL_MS = 30000;

function beep() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [0, 0.18].forEach((t) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = "sine"; o.frequency.value = t ? 1046 : 784;
      g.gain.setValueAtTime(0.0001, ctx.currentTime + t); g.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + t + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + t + 0.16);
      o.connect(g).connect(ctx.destination); o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + 0.18);
    });
  } catch (e) { console.debug("HandoffNotifier: audio non disponibile", e); }
}

export default function HandoffNotifier({ enabled }) {
  const seen = useRef(new Set(JSON.parse(sessionStorage.getItem(KEY) || "[]")));
  const first = useRef(true);
  useEffect(() => {
    if (!enabled) return undefined;
    if ("Notification" in window && Notification.permission === "default") Notification.requestPermission().catch(() => {});
    const check = async () => {
      try {
        const r = await api.waHandoffs("waiting");
        const fresh = r.items.filter((h) => !seen.current.has(h.id));
        r.items.forEach((h) => seen.current.add(h.id));
        sessionStorage.setItem(KEY, JSON.stringify([...seen.current].slice(-200)));
        if (first.current) { first.current = false; return; }
        fresh.forEach((h) => {
          beep();
          const body = `${h.phone}${h.name ? " · " + h.name : ""} — ${h.reason || "Richiesta operatore"}`;
          toast("Nuova richiesta operatore su WhatsApp", { description: body + " · apri un concorso → tab WhatsApp → Chat in attesa", duration: 15000 });
          if ("Notification" in window && Notification.permission === "granted") {
            const n = new Notification("Vivi Win · Richiesta operatore", { body, icon: "/brand/nouvelle-contest.png", tag: h.id });
            n.onclick = () => { window.focus(); n.close(); };
          }
        });
      } catch (e) { if (e?.response?.status !== 401) console.debug("HandoffNotifier: polling fallito", e); }
    };
    check();
    const t = setInterval(check, POLL_MS);
    return () => clearInterval(t);
  }, [enabled]);
  return null;
}
